// FormularioRemoto, vista de creación de formulario por parte de una visita de manera remota


//Imports 
import React, {createRef} from 'react';
import {Card, Row, Col, Form, Input, Button, Select, notification, Modal, Avatar, Spin, Divider} from 'antd';
import ImgCrop from 'antd-img-crop';
import {Upload, message, DatePicker, Space} from 'antd';
import {LoadingOutlined, UploadOutlined, ExclamationCircleOutlined, CloseCircleTwoTone, ExclamationCircleTwoTone} from '@ant-design/icons';
import {
    getTypesVisits,
    getCiudades,
    getOrganismos,
    getRegiones,
    getPaises,
    getVisitEnlace,
    getEstadosCiviles,
    crearFormularioRemoto,
    getMunicipios,
    checkrut,
    getFormVisitRut
} from "./VisitConsumer";
import 'antd/dist/antd.css';
import moment from 'moment';
import axios from "axios/index";




const {Option} = Select;
const {confirm} = Modal;

const form = createRef();

// Funcion de lectura de imagen
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

// Funcion de lectura de imagen
function getMeta(file){
    return new Promise (function (resolved, rejected) {
        var i = new Image()
        i.onload = function(){
        resolved({w: i.width, h: i.height})
        };
        i.src = file
    }) 
}

// Verifica el tipo de imagen (jpg, png)
function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Imagen debe ser mas pequeña que 2MB!');
    }
    return isJpgOrPng && isLt2M;
}

// Se debe modificar a una base de datos de prefijos de paises, se puede agregar al input telefono
// Actualmente no está dentor del campo.
const prefixSelector = (
    <Form.Item name="prefix" noStyle>
        <Select className="telefono">
            <Option value="56">+56</Option>
        </Select>
    </Form.Item>
);

// Validaciones
/* eslint-disable no-template-curly-in-string */
const validateMessages = {
    required: '${label} es requerido',
    types: {
        email: '${label} no es válido como email',
        number: '${label} no es un número válido',
    },
    number: {
        range: '${label} debe estar entre ${min} y ${max}',
    },
};

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

// Componente que se muestra finalmente
class FormularioRemoto extends React.Component {
    // Estado de la imagen
    state = {
        loading: false,
        visit: null,
        visitas: [],
        ciudades: [],
        municipios: [],
        paises: [],
        organismos: [],
        facultades: [],
        unidades: [],
        estados_civiles: [],
        image: null,
        filtered_regiones: [],
        filtered_ciudades: [],
        filtered_municipios: [],
        loadings: [],
        visits: [],
        existeImagen: null,
        pais_length: '',
        region_length: '',
        ciudad_length: '',
        municipios_length: '',
        esChile: true,
        visitaSinCargar: true,
        modalWidth:'240px',
        modalErrorEnlace: 0,
        submitButtonload: false,
        modalEsUChile: false,
        modalRutRepetido: false,
        modalEsVigente: false,
        modalErrorBackend: false,
        modalProrrogaOk: false,
    };

    enterLoading = index => {
        this.setState(({loadings}) => {
            const newLoadings = [...loadings];
            newLoadings[index] = true;
            return {
                loadings: newLoadings,
            };
        });
    };

    datosCampos= () =>{
        console.log("fields:",form.current.getFieldValue())
        console.log("image: ", this.state.image)
    }

    calcular_largo(data_array,pix_multi) {
        let string_length = 0;
        data_array.map(info => {
            if(string_length < info.nombre.length){
                string_length = info.nombre.length;
            }
        })
        string_length = string_length*pix_multi;
        return(string_length.toString()+'px')
    }

    componentDidMount() {
        //Hacemos request a la API para rellenar las boxes del formulario
        getVisitEnlace(this.props.match.params.url).then((responseVisitEnlace) => {
            if(responseVisitEnlace.data.enlace_invalido === 0){
                getEstadosCiviles().then((response) => {
                    console.log("estados civiles", response)
                    this.setState({estados_civiles: response.data})
                });
                getTypesVisits().then((response) => {
                    this.setState({visitas: response.data})
                });
                getCiudades().then((response) => {
                    this.setState({ciudades: response.data, ciudad_length: this.calcular_largo(response.data,10)});
                });
                getMunicipios().then((response) => {
                    this.setState({municipios: response.data.municipio});
                });
                getPaises().then((response) => {
                    this.setState({paises: response.data, pais_length: this.calcular_largo(response.data,10)});
                });
                getRegiones().then((response) => {
                    this.setState({regiones: response.data, region_length: this.calcular_largo(response.data,10)});
                    // Valor default del País
                    this.setState({
                        filtered_regiones :  response.data.filter((region)  => parseInt(region.id_pais) === window.ENV.CONSTANTE_ID_CHILE)
                    });
                    this.setState({visitaSinCargar: false});
                    /* if(responseVisitEnlace.data.data.length === 1){
                        this.setState({visitaSinCargar: false});
                        //this.setState({visits: responseVisitEnlace.data.data[0], visitaSinCargar: false});
                        //this.cargarDatosForm(responseVisitEnlace.data.data[0])
                        //this.setState({visitaSinCargar: false})
                    } */
                });
                getOrganismos().then((response) => {
                    this.setState({
                        organismos: response.data,
                    });
                });
            } else {
                this.setState({modalErrorEnlace: 1})
            }
        });
    };

    beforeCrop= (info) => {
        getBase64(info, imageUrl => {
            getMeta(imageUrl).then((response) => {
                let dimensionW = response.w;
                if(dimensionW > 600){
                    this.setState({modalWidth: '600px'});
                }else{
                    this.setState({modalWidth: dimensionW.toString()+'px'});
                }
            });
        });
        return info;
    }

    parseRut = rutP =>{
        if(rutP != null){
            let flag_0 = 0;
            let rut_data = rutP;
            let rutPasaporte = '';
            if(rut_data[0] != 'P'){
                for (let i = 0; i < rut_data.length; i++) {
                    if(rut_data[i] != 0){
                        flag_0 = 1;
                    }
                    if(flag_0 == 1){
                        if(i < rut_data.length-1){
                            rutPasaporte = rutPasaporte + rut_data[i]
                        }else{
                            rutPasaporte = rutPasaporte + '-' + rut_data[i]
                        }
                    }
                }
            }else{
                rutPasaporte = rut_data;
            }
            return rutPasaporte;
        }
    }

    /* cargarDatosForm = data => {
        if (data.ID_FORMULARIO.RUT_PASAPORTE != ""){
            const res2 = this.state.ciudades.filter(function (ciudad) {
                return [data.ID_FORMULARIO.ID_CIUDAD].indexOf(ciudad?.id_ciudad) >= 0;
            });
            //form.current.resetFields()
            let rutCorregido = this.parseRut(data.ID_FORMULARIO.RUT_PASAPORTE)

            //nuevo
            //AGREGAR ESTADO CIVIL
            if(res2.length > 0){
                this.handleonChange_pais(res2[0].id_pais)
                this.handleonChange_region(res2[0].id_region)
                form.current.setFieldsValue({
                    rut_pasaporte: rutCorregido,
                    nombres: data.ID_FORMULARIO.NOMBRES,
                    paterno: data.ID_FORMULARIO.PATERNO,
                    materno: data.ID_FORMULARIO.MATERNO,
                    address: {street: data.ID_FORMULARIO.DIRECCION, country: res2[0].id_pais, region: res2[0].id_region, city: data.ID_FORMULARIO.ID_CIUDAD},
                    birthday: moment(data.ID_FORMULARIO.FECHA_NACIMIENTO, 'YYYY-MM-DD'),
                    gender: data.ID_FORMULARIO.GENERO,
                    phone: data.ID_FORMULARIO.TELEFONO + "",
                    estado_civil: data.ID_FORMULARIO.ID_ESTADO_CIVIL
                })
            } else {
                this.handleonChange_pais(data.ID_FORMULARIO.ID_PAIS)
                this.handleonChange_region(-1) //-1 para que no encuentre ninguna region
                form.current.setFieldsValue({
                    rut_pasaporte: rutCorregido,
                    nombres: data.ID_FORMULARIO.NOMBRES,
                    paterno: data.ID_FORMULARIO.PATERNO,
                    materno: data.ID_FORMULARIO.MATERNO,
                    address: {street: data.ID_FORMULARIO.DIRECCION, country: data.ID_FORMULARIO.ID_PAIS},
                    birthday: moment(data.ID_FORMULARIO.FECHA_NACIMIENTO, 'YYYY-MM-DD'),
                    gender: data.ID_FORMULARIO.GENERO,
                    phone: data.ID_FORMULARIO.TELEFONO + "",
                    estado_civil: data.ID_FORMULARIO.ID_ESTADO_CIVIL
                })
            }
            this.setState({existeImagen: data.ID_FORMULARIO.picture_by_rca, visitaSinCargar: false})
        }
        this.setState({visitaSinCargar: false})
    }; */

    // Informacion de subida de imagen
    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, imageUrl =>
                this.setState({
                    imageUrl,
                    loading: false,
                }),
            );
            this.setState({image: info.file.originFileObj});
        }
    };

    //Filtra regiones según  cambia el país 
    handleonChange_pais = (value,event) => {
        form.current.setFieldsValue({
            address: {region: null, city: null},
        })
        if(value !== window.ENV.CONSTANTE_ID_CHILE){
            let ciudades =  this.state.ciudades;
            this.setState({esChile: false,
                filtered_regiones : [],
                filtered_municipios: [],
                filtered_ciudades :  ciudades.filter((ciudad)  => parseInt(ciudad.id_pais) === parseInt(value))
            });
            return
        } else {
            this.setState({esChile: true})
        }
        var regiones =  this.state.regiones
        this.setState({
            filtered_regiones :  regiones.filter((region)  => parseInt(region.id_pais) === parseInt(value)),
            filtered_ciudades : [],
            filtered_municipios: []
        });
    }
    //Filtra ciudades según cambia region 
    handleonChange_region = (value,event) => {
        form.current.setFieldsValue({
            address: {city: null},
        })
        if(this.state.esChile){
            let municipios = this.state.municipios;
            console.log("Municipios: ", municipios)
            this.setState({
                filtered_municipios :  municipios.filter((municipio)  => parseInt(municipio.id_region) === parseInt(value))
            });
        } else {
            var ciudades =  this.state.ciudades
            this.setState({
                filtered_ciudades :  ciudades.filter((ciudad)  => parseInt(ciudad.id_region) === parseInt(value))
            });
        }
    }

    verificarRut = data => {
        this.setState({visitaSinCargar : true})
        if(data.target.value === ""){
            this.setState({visitaSinCargar : false})
            return;
        }
        let visita = this.state.visits
        let rutRecibido = data.target.value
        if(rutRecibido[0] === 'p'){
            this.setState({visitaSinCargar : false})
            return;
        }
        if(rutRecibido[0].toUpperCase() != "P"){
            var dataF = rutRecibido.replace("-","")
            for(let ix=0;ix<10-rutRecibido.replace("-","").length;ix++){
                dataF = "0" + dataF;
            }
        } else {
            var dataF = data.target.value;
        }
        checkrut(dataF.toUpperCase()).then(respCheckRut => {
            if(respCheckRut.data.esUChile){
                this.setState({visitaSinCargar : false});
                this.setState({modalEsUChile: true});
                return;
            }
            if(respCheckRut.data.esVigente){
                this.setState({visitaSinCargar : false})
                this.setState({modalProrrogaOk: true});
                return;
            }
            if (respCheckRut.data.verificacion) {
                getFormVisitRut(dataF.toUpperCase()).then((response) => {
                    let res = [response.data]
                    let rutIngresado = form.current.getFieldValue().rut_pasaporte
                    if (res.length > 0 && res[0].id_visita != -1){
                        /* const res2 = this.state.ciudades.filter(function (ciudad) {
                            return [res[0].ID_FORMULARIO.IdCiudad].indexOf(ciudad?.id_ciudad) >= 0;
                        }); */
                        this.setState({visitas: res[0]});
                        //AGREGAR ESTADO CIVIL
                        if(res[0].ID_FORMULARIO.IdEstadoCivil === 0){
                            res[0].ID_FORMULARIO.IdEstadoCivil = 1
                        }
                        if(res[0].ID_FORMULARIO.FotoPersona != ""){
                            this.setState({tieneFoto: true})
                        }
                        if(res[0].ID_FORMULARIO.IdNacionalidad === 0){
                            res[0].ID_FORMULARIO.IdNacionalidad = window.ENV.CONSTANTE_ID_CHILE
                        }
                        if(res[0].ID_FORMULARIO.IdPais == window.ENV.CONSTANTE_ID_CHILE && res[0].ID_FORMULARIO.IdRegion != 0 && res[0].ID_FORMULARIO.IdCiudad != 0) {
                            this.handleonChange_pais(res[0].ID_FORMULARIO.IdPais)
                            this.handleonChange_region(res[0].ID_FORMULARIO.IdRegion)
                            form.current.setFieldsValue({
                                rut_pasaporte: rutIngresado,
                                nombres: res[0].ID_FORMULARIO.Nombres,
                                paterno: res[0].ID_FORMULARIO.Paterno,
                                materno: res[0].ID_FORMULARIO.Materno,
                                user: {email: res[0].ID_FORMULARIO.Email},
                                nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais, region: res[0].ID_FORMULARIO.IdRegion, city: res[0].ID_FORMULARIO.IdCiudad},
                                birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                gender: res[0].ID_FORMULARIO.Genero,
                                phone: res[0].ID_FORMULARIO.Telefono + "",
                                estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                            })
                        } else {
                            this.handleonChange_pais(res[0].ID_FORMULARIO.IdPais)
                            //this.handleonChange_region(-1) //-1 para que no encuentre ninguna region
                            if(res[0].ID_FORMULARIO.IdCiudad != 0){
                                form.current.setFieldsValue({
                                    rut_pasaporte: rutIngresado,
                                    nombres: res[0].ID_FORMULARIO.Nombres,
                                    paterno: res[0].ID_FORMULARIO.Paterno,
                                    materno: res[0].ID_FORMULARIO.Materno,
                                    user: {email: res[0].ID_FORMULARIO.Email},
                                    nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                    address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais, city: res[0].ID_FORMULARIO.IdCiudad},
                                    birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                    gender: res[0].ID_FORMULARIO.Genero,
                                    phone: res[0].ID_FORMULARIO.Telefono + "",
                                    estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                                })
                            } else {
                                form.current.setFieldsValue({
                                    rut_pasaporte: rutIngresado,
                                    nombres: res[0].ID_FORMULARIO.Nombres,
                                    paterno: res[0].ID_FORMULARIO.Paterno,
                                    materno: res[0].ID_FORMULARIO.Materno,
                                    user: {email: res[0].ID_FORMULARIO.Email},
                                    nacionalidad: res[0].ID_FORMULARIO.IdNacionalidad,
                                    address: {street: res[0].ID_FORMULARIO.Direccion, country: res[0].ID_FORMULARIO.IdPais},
                                    birthday: moment(res[0].ID_FORMULARIO.FechaNacimiento, 'YYYY-MM-DD'),
                                    gender: res[0].ID_FORMULARIO.Genero,
                                    phone: res[0].ID_FORMULARIO.Telefono + "",
                                    estado_civil: res[0].ID_FORMULARIO.IdEstadoCivil
                                })
                            }
                        }
                    } else {
                        form.current.resetFields()
                        form.current.setFieldsValue({
                            rut_pasaporte: rutIngresado,
                        })
                    }
                    this.setState({visitaSinCargar: false});
                });
            } else {
                let rutIngresado = form.current.getFieldValue().rut_pasaporte
                form.current.resetFields()
                form.current.setFieldsValue({
                    rut_pasaporte: rutIngresado,
                })
                this.setState({visitas: [],visitaSinCargar: false});
            }
        });
    };

    submitForm = () => {
        this.setState({submitButtonload: true});
        let rutRecibido = form.current.getFieldValue('rut_pasaporte');
        if(rutRecibido == undefined){
            this.setState({submitButtonload: false});
            form.current.submit();
            return;
        }
        if(rutRecibido[0] === 'p'){
            this.setState({visitaSinCargar : false})
        }else{
            if(rutRecibido[0].toUpperCase() != "P"){
                var dataF = rutRecibido.replace("-","")
                for(let ix=0;ix<10-rutRecibido.replace("-","").length;ix++){
                    dataF = "0" + dataF;
                }
            } else {
                var dataF = form.current.getFieldValue('rut_pasaporte');
            }
            checkrut(dataF.toUpperCase()).then(respCheckRut => {
                this.setState({submitButtonload: false});
                if(respCheckRut.data.esUChile){
                    this.setState({modalEsUChile: true});
                }else if(respCheckRut.data.esVigente){
                    this.setState({modalProrrogaOk: true});
                }else{
                    form.current.submit();
                }
            })
        }
    }

    // Formulario
    render() {
        const hideModalProrrogaOk = () => {
            this.setState({
                modalProrrogaOk: false,
                submitButtonload: false
            });
        }

        const buttonNotLoading = () => {
            this.setState({
                submitButtonload: false,
            });
        };
        //TODO: Manejo de errores 503, 400 y otros
        const visit_url = this.props.match.params.url;
        //Funcion para cuando se rellena correctamente el formulario y se envia.
        const onFinish = values => {
            this.setState({submitButtonload: true})
            values.visit_url = visit_url
            
            if(this.state.image){
                values.photo = this.state.image;
            } else {
                values.photo = null;
            }
            if(!values.photo && this.state.visitas.ID_FORMULARIO.FotoPersona === ''){
                this.setState({submitButtonload: false})
                notification.open({
                    message: "Error",
                    description: "Debe subir una foto",
                    type: "error",
                    duration: 5,
                });
                return
            }
            values.tiene_foto = values.photo === null && this.state.visitas.ID_FORMULARIO.FotoPersona !== ""

            if(values.rut_pasaporte[0].toUpperCase() != "P"){
                var dataF = values.rut_pasaporte.replace("-","")
                for(let ix=0;ix<10-values.rut_pasaporte.replace("-","").length;ix++){
                    dataF = "0" + dataF
                }
                values.rut_pasaporte = dataF
            }

            if(!values.materno){
                values.materno = ''
            }
            if(!values.address.city){
                values.address.city = null
            }

            //const enterLoading = this.enterLoading;
            values.rut_pasaporte = values.rut_pasaporte.toUpperCase();
            //Pop up confirmación de envio
            confirm({
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                content: <div><div style={{textAlign:"center", marginBottom: "40px"}}><ExclamationCircleOutlined style={{fontSize: "60px", color: "#FFBA5C"}}/></div><div style={{fontSize: "19px", color:"#8190A5", marginBottom: "20px", textAlign:"center"}}><div>¿Estás seguro de esta acción?</div><div>No podrás modificar la información ingresada después de enviar el formulario.</div></div></div>,
                cancelButtonProps: {className: 'global-secundario-button'},
                okButtonProps: {className: 'global-principal-button'},
                width:"600px",
                onOk() {
                    //No hay que crear un form nuevo, si no que modificamos el que ya esta asociado a este link/mail
                    crearFormularioRemoto(values).then(function (response) {
                        console.log(response.data.insertado)
                        if (response.data.insertado === 1) {
                            window.setTimeout(function () {
                                window.location.href= window.location.href + "/successful";
                            },0); 
                        } else {
                            this.setState({submitButtonload: false, modalErrorBackend: true})
                        }
                    }).catch(function (error) {
                        //En caso de error mostramos este mensaje 
                    });
                },
                onCancel() {
                    buttonNotLoading()
                },
            });
        };

        // Funcion de Upload de imagen
        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined style={{color:"#116EC0"}}/> : <UploadOutlined style={{color:"#116EC0", fontSize:"25px"}}/>}
                <div className='formvisit-upload-text'><b>SUBIR FOTO</b></div>
            </div>
        );

        // Cambio de URL de la imagen cuando es subida
        const { imageUrl } = this.state;

        // para boton loading
        const {loadings} = this.state;

        return (
            <div>
            <Modal visible={this.state.modalErrorEnlace} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                    <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>El enlace no es válido o este formulario ya fue completado una vez.</div>
                {/* <Divider style={{background: '#969FAA'}}/>
                <div style={{textAlign: 'right'}}>
                    <Button className='global-principal-button' onClick={() => window.location.reload()} >ACEPTAR</Button>
                </div> */}
            </Modal>
            <Modal visible={this.state.modalEsUChile} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                    <ExclamationCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FFBA5C"/>
                    <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Este RUT/Pasaporte ya tiene un vínculo con la Universidad y no se puede crear como visita</div>
                <Divider style={{background: '#969FAA'}}/>
                <div style={{textAlign: 'right'}}>
                    <Button className='global-principal-button' onClick={() => this.setState({modalEsUChile: false})} >ACEPTAR</Button>
                </div>
            </Modal>
            <Modal visible={this.state.modalErrorBackend} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                    <ExclamationCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FFBA5C"/>
                    <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Ocurrió un error al ingresar los datos. contactar con mesa de ayuda.</div>
                <Divider style={{background: '#969FAA'}}/>
                <div style={{textAlign: 'right'}}>
                    <Button className='global-principal-button' onClick={() => this.setState({modalErrorBackend: false})} >ACEPTAR</Button>
                </div>
            </Modal>
            <Modal visible={this.state.modalRutRepetido} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                    <ExclamationCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FFBA5C"/>
                    <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Este rut ya fue ingresado, contactar con mesa de ayuda</div>
                <Divider style={{background: '#969FAA'}}/>
                <div style={{textAlign: 'right'}}>
                    <Button className='global-principal-button' onClick={() => this.setState({modalRutRepetido: false})} >ACEPTAR</Button>
                </div>
            </Modal>
            <Modal visible={this.state.modalProrrogaOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                    <ExclamationCircleOutlined style={{fontSize: "49px", color:"#FFBA5C"}}/>
                    <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Esta persona tiene una visita a esta facultad con menos de 6 meses de su finalización o tiene una visita vigente. Comuniquese con mesa de ayuda.</div>
                <Divider style={{background: '#969FAA'}}/>
                {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                <div style={{textAlign: 'right'}}>
                    <Button className='global-principal-button' onClick={() => {hideModalProrrogaOk()}} >ACEPTAR</Button>
                </div>
            </Modal>
            <Spin spinning={this.state.visitaSinCargar}>
            <Row>

                <Card>
                    <div style={{fontSize:"25px", color:"#1978B8"}}><b>Formulario remoto</b></div>
                    <div style={{fontSize:"15px", color:"#5A6978"}}><b>Completa el formulario para que puedan aprobar tu visita.</b></div>
                    <br/>
                    <Form ref={form} layout={'vertical'} name="nest-messages" onFinish={onFinish}
                          validateMessages={validateMessages}>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item
                                    name='rut_pasaporte'
                                    label={<label className='formvisit-label'>RUT / Pasaporte</label>}
                                    rules={[{required: true, message: 'RUT o Pasaporte es requerido'}, {
                                        message: 'Formato RUT es 12345678-9 o de Pasaporte es P123456789',
                                        pattern: "^(\\d{1,2}\\d{3}\\d{3}-[\\dkK]|P\\w*)$"},
                                        {
                                            validator: async (rule, value) => {
                                                if(!value){
                                                    return;
                                                }
                                                if (value[0] === 'P' && value.length > 5){
                                                    return;
                                                }
                                                if (value.split("-").length < 2 || value.split("-")[1].length != 1) {
                                                    throw new Error('RUT incorrecto.');
                                                }
                                                let rut = value.split("-")[0];
                                                let verificador = '' + value.split("-")[1];
                                                let verCalc = '';
                                                let sum = 0;
                                                let mul = 2;
                                            
                                                let i = rut.length;
                                                while (i--) {
                                                sum = sum + parseInt(rut.charAt(i)) * mul;
                                                if (mul % 7 === 0) { mul = 2; }
                                                else { mul++; }
                                                }
                                            
                                                const res = '' + sum % 11;
            
                                                if (res === '0'){
                                                    verCalc = '0';
                                                } else {
                                                    if (res === '1'){
                                                        verCalc = 'k';
                                                    } else {
                                                        verCalc = '' + (11-res)
                                                    }
                                                }
                                                if (verificador.toUpperCase() === verCalc.toUpperCase()){
                                                    return;
                                                } else {
                                                    console.log("DV incorrecto")
                                                    throw new Error('RUT incorrecto.');
                                                }
                                            }
                                        }
                                        ]}>
                                    <Input style={{ width: "100%" }}  onBlur={this.verificarRut}  className='formvisit' placeholder="12345678-9 / P123456789"/>
                                </Form.Item>
                                <Form.Item name='nombres' label={<label className='formvisit-label'>Nombres</label>}
                                   rules={[{required: true, message: "Nombres son requeridos"}, {
                                       pattern: "^([^0-9]*)$",
                                       message: "Nombre no puede tener números"
                                   }]}>
                                    <Input className='formvisit'/>
                                </Form.Item>

                                <Form.Item name='materno' label={<label className='formvisit-label'>Segundo apellido</label>}
                                   rules={[{
                                       pattern: "^([^0-9]*)$",
                                       message: "Apellido no puede tener números"
                                   }]}>
                                    <Input className='formvisit'/>
                                </Form.Item>

                                <Form.Item name="estado_civil" label={<label className='formvisit-label'>Estado Civil</label>} rules={[{required: true, message: "Estado civil es requerido"}]}>
                                    <Select
                                        placeholder="Selecciona una opción"
                                        allowClear
                                        className='formvisit-select'
                                    >
                                        {this.state.estados_civiles.map(estCivil => (
                                            <Option
                                                value={parseInt(estCivil.id_estado_civil)}>{estCivil.nombre}</Option>
                                        ))}

                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={<label className='formvisit-label'>Nacionalidad</label>}
                                    name = "nacionalidad"
                                    rules={[{required: true, message: "Nacionalidad es requerida"}]}
                                    initialValue={window.ENV.CONSTANTE_ID_CHILE}
                                >
                                    <Select  
                                    className='formvisit-select' /* style={{ width: this.state.pais_length}} */ 
                                    placeholder="Selecciona una nacionalidad"
                                    optionFilterProp="children"
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                        {this.state.paises.map(pais => (
                                            <Option value={pais.id_pais} key={pais.id_pais}>{pais.nacionalidad}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}> 
                                <Form.Item name="birthday" label={<label className='formvisit-label'>Fecha de nacimiento</label>} rules={[{
                                    type: 'object',
                                    required: true,
                                    message: 'Fecha de nacimiento es requerida'
                                }]}>
                                    <DatePicker style={{height: "35px", width: "238px", borderColor: "#A3AEBB"}} placeholder="Fecha de nacimiento" format={'YYYY-MM-DD'}/>
                                </Form.Item>
                                <Form.Item name='paterno' label={<label className='formvisit-label'>Primer apellido</label>}
                                    rules={[{
                                        required: true,
                                        message: "Primer apellido es requerido"
                                    }, {
                                        pattern: "^([^0-9]*)$",
                                        message: "Apellido no puede tener números"
                                    }]}>
                                    <Input className='formvisit'/>
                                </Form.Item>
                                <Form.Item name="gender" label={<label className='formvisit-label'>Género</label>} rules={[{required: true, message: "Género es requerido"}]}>
                                    <Select
                                        placeholder="Selecciona una opción"
                                        allowClear
                                        className='formvisit-select'
                                    >
                                        <Option value="Masculino">Masculino</Option>
                                        <Option value="Femenino">Femenino</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name="phone"
                                    label={<label className='formvisit-label'>Teléfono</label>}
                                    rules={[{required: true, message: "Teléfono es requerido"}, {
                                        message: 'Formato Teléfono es 123456789',
                                        pattern: "^[0-9]*$"
                                    }]}
                                >
                                    <Input className='formvisit'/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: 10}}>
                            <Space horizontal>
                            <div style={{color:"#34AAE9", fontWeight: "bold", fontSize: "16px"}}>Importante:</div><div style={{color:"#667487", fontSize: "16px"}}> Si la persona no es de Chile, los campos Ciudad y Región </div><div style={{color:"#667487", fontWeight: "bold", fontSize: "16px"}}> no son obligatorios</div>
                            </Space>
                        </Row>
                        <br/>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item
                                    label={<label className='formvisit-label'>País</label>}
                                    name={['address', 'country']}
                                    rules={[{required: true, message: "País es requerido"}]}
                                    initialValue={window.ENV.CONSTANTE_ID_CHILE}
                                >
                                    <Select 
                                        className='formvisit-select' /* style={{ width: this.state.pais_length }} */ 
                                        placeholder="Selecciona un país" 
                                        onSelect={(value,event)=> this.handleonChange_pais(value,event)}
                                        optionFilterProp="children"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {this.state.paises.map(pais => (
                                            <Option value={pais.id_pais} key={pais.id_pais}>{pais.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    label={<label className='formvisit-label'>Ciudad</label>}
                                    name={['address', 'city']}
                                    rules={[{required: this.state.esChile, message: "Ciudad es requerida"}]}
                                >
                                    <Select 
                                        className='formvisit-select' /* style={{ width: this.state.ciudad_length }} */ 
                                        placeholder="Selecciona una Ciudad"
                                        optionFilterProp="children"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {this.state.esChile ? this.state.filtered_municipios.map(municipio => (
                                            <Option value={municipio.id_municipio} key={municipio.id_municipio}>{municipio.nombre}</Option>
                                        )) : this.state.filtered_ciudades.map(ciudad => (
                                            <Option value={ciudad.id_ciudad} key={ciudad.id_ciudad}>{ciudad.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label={<label className='formvisit-label'>Región</label>}
                                    name={['address', 'region']}
                                    rules={[{required: this.state.esChile, message: "Región es requerida"}]}
                                >
                                    <Select 
                                        className='formvisit-select' /* style={{ width: this.state.region_length }} */ 
                                        placeholder="Selecciona una región" 
                                        disabled={ !this.state.esChile}
                                        onSelect={(value,event)=> this.handleonChange_region(value,event)}
                                        optionFilterProp="children"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {this.state.filtered_regiones.map(region => (
                                            <Option value={region.id_region} key={region.id_region}>{region.nombre}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                
                                <Form.Item
                                    label={<label className='formvisit-label'>Dirección</label>}
                                    name={['address', 'street']}
                                    rules={[{required: true, message: 'Dirección es requerida'}]}
                                >
                                    <Input className='formvisit' style={{ width: "100%" }} placeholder="Dirección"/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item name="photo" label={<label><Row><div className='formvisit-required-icon'>*</div> <div className='formvisit-label'>Foto de perfil</div> </Row></label>} rules={[{required: false}]}>
                        <ImgCrop grid rotate modalTitle="Editar imagen" aspect="0.75" /* modalWidth={this.state.modalWidth} beforeCrop={this.beforeCrop} */ >
                                <Upload
                                    name="avatar"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    customRequest={dummyRequest}
                                    beforeUpload={beforeUpload}
                                    onChange={this.handleChange}
                                >
                                    {imageUrl ? <img style={{width:"100%"}} src={imageUrl} alt="avatar"/> : uploadButton}
                                </Upload>
                            </ImgCrop>
                        </Form.Item>
                        { this.state.visitas.ID_FORMULARIO ? <Avatar src={`${this.state.visitas.ID_FORMULARIO.FotoPersona}`}shape="square" style={{width: "20%", height:"27%"}}/>: null}
                        <br/>
                        <br/>
                        <b style={{color:"#4B5660"}}>Características que debe tener la fotografía</b>:
                        <ol style={{color:"#4B5660"}}>
                            <li>Fotografía en color: Sin sombras, reflejos o filtros.</li>
                            <li>Encuadre: Sólo rostro, frontal y centrada (área de cobertura estándar de foto
                                carnet). No incluir número de carnet.
                            </li>
                            <li>No utilizar anteojos, sombreros ni otros accesorios que cubran total o parcialmente
                                el rostro.
                            </li>
                            <li>Fondo: Color blanco o crema, sin texturas, diseños ni paisajes de fondo.</li>
                            <li>La fotografía no debe ser escaneada ni verse borrosa.</li>
                        </ol>
                        <Divider/>

                        <Form.Item>
                            <Button 
                                className='formvisit-send-button'
                                onClick={() => {this.submitForm()}}
                                loading={this.state.submitButtonload}
                            >
                                ENVIAR
                            </Button>
                            {/* <Button 
                                type="primary" 
                                htmlType="button"
                                onClick={this.datosCampos}
                            >
                                ver datos
                            </Button> */}
                        </Form.Item>
                    </Form>

                </Card>
            </Row>
            </Spin>
            </div>
        );
    }
}

export default FormularioRemoto;